import { contactSectionTwo, conractInformation } from "data/contactSection";
import Message from "components/MessagePopup/MessagePopup";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import axios from 'axios';


const { title, text, socials } = contactSectionTwo;

const ContactSectionTwo = () => {

  const [show, setShow] = useState(false);
  const [success, setSucces] = useState(false);
  const [errors, setErrors] = useState(false);
  const [textr, seText] = useState("");

  const [userName, setUserName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")

  const handleSuccess = () => {
    setSucces(true);
    setTimeout(() => {
      setSucces(false);
    }, 3000);
  }
  const handleError = () => {
    setErrors(true);
    setTimeout(() => {
      setErrors(false);
    }, 3000);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    let data = new FormData();
    formData.forEach((value, name) => (data.append(name, value)));
    // console.log(data);

    axios
      .post(
        conractInformation.endpoint,
        data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(function (response) {
        if (response.status == 200) {
          handleSuccess();
          seText('Email Sent Successfully!');
          setUserName('');
          setMessage('');
          setEmail('');
        }
      })
      .catch(error => {
        handleError();
        seText('Something Went Wrong Please Try Again');
        // console.log(error);
      });
  };

  return (
    <section className="contact-section contact-two">
      <div className="auto-container">
        <Row>
          <Col lg={4}>
            <div className="contact-two__content">
              <div className="sec-title">
                <h2>
                  {title} <span className="dot">.</span>
                </h2>
              </div>
              <p className="contact-two__text">{text}</p>
              <div className="contact-two__social">
                {socials.map((icon, i) => (
                  <a key={i} href="#" className={icon}></a>
                ))}
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="form-box">
              <div className="default-form">
                <form onSubmit={handleSubmit} id="contact-form">
                  <Row className="clearfix">
                    <Col lg={6} md={6} sm={12} className="form-group">
                      <div className="field-inner">
                        <input
                          type="text"
                          name="userName"
                          placeholder="Your Name"
                          required
                          onChange={ev => { setUserName(ev.target.value) }}
                          value={userName}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} className="form-group">
                      <div className="field-inner">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email Address"
                          required
                          onChange={ev => { setEmail(ev.target.value) }}
                          value={email}
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} className="form-group">
                      <div className="field-inner">
                        <textarea
                          name="message"
                          placeholder="Write Message"
                          required
                          onChange={ev => { setMessage(ev.target.value) }}
                          value={message}
                        ></textarea>
                      </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} className="form-group">
                      {success && <Message variant='success'>{textr}</Message>}
                      {errors && <Message variant='danger'>{textr}</Message>}
                    </Col>
                    <Col lg={12} md={12} sm={12} className="form-group">
                      <button className="theme-btn btn-style-one">
                        <i className="btn-curve"></i>
                        <span className="btn-title">Send message</span>
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ContactSectionTwo;
